import Glide from "@glidejs/glide";
import { getElement, getElements, ifSelectorExist, getCookie } from './utils';

export const hvacSliders = () => {
  const reviewsSlider = ".millers-reviews__slider";
  if (ifSelectorExist(reviewsSlider)) {
    Array.from(getElements(reviewsSlider)).forEach((item) => {
      new Glide(item, {
        perView: 1,
        type: "carousel",
        dots:true,
      }).mount();
    });
  }
};